<nz-table #rubricTable [nzData]="rubrics" [nzLoading]="rubricService.loading$ | async" [nzNoResult]="noData">
	<thead>
		<tr>
			<th>Code</th>
			<th>Label</th>
			<th>Display Order</th>
			<th>Created</th>
			<th>Updated</th>
			<th>Actions</th>
		</tr>
	</thead>
	<tbody>
		@for (rubric of rubrics; track $index) {
			<tr [class.selected]="rubric.code === rubricService.selectedRubricBs$.value?.code">
				<td>{{ rubric.code }}</td>
				<td>{{ rubric.label }}</td>
				<td>{{ rubric.display_order }}</td>
				<td>{{ rubric.created | date: 'medium' }}</td>
				<td>{{ rubric.updated | date: 'medium' }}</td>
				<td>
					@if (mode === 'edit') {
						@if (rubric.code === rubricService.selectedRubricBs$.value?.code) {
							<button nz-button (click)="selectRubric(undefined)">Clear</button>
						}
						@if (rubric.code !== rubricService.selectedRubricBs$.value?.code) {
							<span>&nbsp;</span>
							<button nz-button nzType="primary" (click)="selectRubric(rubric)">Edit</button>
						}
						<span>&nbsp;</span>
						<button
							nz-button
							nzDanger
							nz-popconfirm
							nzPopconfirmTitle="Are you sure delete this?"
							nzPopconfirmPlacement="bottom"
							(nzOnConfirm)="deleteRubric(rubric.code)"
						>
							Delete
						</button>
					}
					@if (mode === 'select') {
						<span>&nbsp;</span>
						<button nz-button nzType="primary" (click)="selectRubric(rubric)">Select</button>
					}
				</td>
			</tr>
		}
	</tbody>
	<ng-template #noData>
		<nz-typography>No rubrics available</nz-typography>
	</ng-template>
</nz-table>
